import api from '@/helpers/api'
import axios from '@/helpers/axios'

export default {
    namespaced: true,

    state: {
        checks:{
            immAccount: false,
            companiaMeaInformatiiGenerale: false,
            companiaMeaSediuSocial: false,
            companiaMeaAsociati: false,
            companiaMeaReprezentantLegal: false,
            proiectulMeuCaenEligibil: false,
            proiectulMeuAjutoareStat: false,
            proiectulMeuTitlu: false,
            proiectulMeuAchizitiileProiectului: false,
            proiectulMeuGdpr: false,
            activitati: false,
            obiective: false,
            indicatori: false,
            planDeAfaceriScop: false,
            planDeAfaceriSituatie: false,
            planDeAfaceriObiective: true,
            planDeAfaceriMediuExtern: false,
            planDeAfaceriAnalizaSwot: false,
            planDeAfaceriEtapeTinte: false,
            planDeAfaceriContributieMediu: false,
            planDeAfaceriRiscuri: false
        },
        loaded: false
    },

    getters: {
        checks: state => state.checks,
    },

    mutations: {
        UPDATE_CHECKS(state, item) {
            if(!state.loaded){
                axios.get(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/project/checks')
                    .then( response => {
                        if(response.data.length) {
                            state.checks = JSON.parse(response.data);
                            if(!state.checks.immAccount)
                                state.checks.immAccount = false
                            if(!state.checks.proiectulMeuTitlu)
                                state.checks.proiectulMeuTitlu = false
                            if(!state.checks.proiectulMeuGdpr)
                                state.checks.proiectulMeuGdpr = false
                            if(!state.checks.planDeAfaceriContributieMediu)
                                state.checks.planDeAfaceriContributieMediu = false
                        }
                        state.loaded = true;
                        state.checks[item.name] = item.value;
                        axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/project/checks', {checks: state.checks})
                    })
            }
            else{
                state.checks[item.name] = item.value;
                axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/project/checks', {checks: state.checks})
            }
        },

        INITIALIZE_CHECKS(state) {
            axios.get(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/project/checks')
                .then( response => {
                    if(response.data.length) {
                        state.checks = JSON.parse(response.data);
                        if(!state.checks.immAccount)
                            state.checks.immAccount = false
                        if(!state.checks.proiectulMeuTitlu)
                            state.checks.proiectulMeuTitlu = false
                        if(!state.checks.proiectulMeuGdpr)
                            state.checks.proiectulMeuGdpr = false
                        if(!state.checks.planDeAfaceriContributieMediu)
                            state.checks.planDeAfaceriContributieMediu = false
                    }
                    state.loaded = true;
                })
        },

        RESET_CHECKS(state) {
            state.checks = {
                immAccount: false,
                companiaMeaInformatiiGenerale: false,
                companiaMeaSediuSocial: false,
                companiaMeaAsociati: false,
                companiaMeaReprezentantLegal: false,
                proiectulMeuCaenEligibil: false,
                proiectulMeuAjutoareStat: false,
                proiectulMeuTitlu: false,
                proiectulMeuAchizitiileProiectului: false,
                proiectulMeuGdpr: false,
                activitati: false,
                obiective: false,
                indicatori: false,
                planDeAfaceriScop: false,
                planDeAfaceriSituatie: false,
                planDeAfaceriObiective: true,
                planDeAfaceriMediuExtern: false,
                planDeAfaceriAnalizaSwot: false,
                planDeAfaceriEtapeTinte: false,
                planDeAfaceriContributieMediu: false,
                planDeAfaceriRiscuri: false
            }
        }
    },

    actions: {
        updateChecks({ commit }, item) {
            commit('UPDATE_CHECKS', item)
        },

        initializeChecks({commit}) {
            commit('INITIALIZE_CHECKS')
        },

        resetChecks({commit}) {
            commit('RESET_CHECKS');
        }
    },
}
